import type { FC } from 'react'

import classNames from 'classnames'

export interface IPagItem {
  value: number
  isActive: boolean
  setCurrentPage: (number: number) => void
}

const PaginationItem: FC<IPagItem> = ({ value, isActive, setCurrentPage }) => {
  const liClass = classNames('pagination-item', { 'active-item': isActive })
  return (
    <li onClick={() => setCurrentPage(value)} className={liClass}>
      {value}
    </li>
  )
}

export default PaginationItem
